import React from 'react';
import { Box, Button, IconButton, TextField, Typography } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import DeleteIcon from '@mui/icons-material/Delete';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

const SUGGESTED_TAGS = ['Cor: ', 'Saúde da bateria ', '128GB', 'Seminovo', 'Preço Promocional'];

const ProductTagsEditor = () => {
  const { control, register, setValue, getValues } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'tags',
  });

  const handleAddSuggested = (text) => {
    append({ description: text, highlighted: false });
  };

  const handleHighlight = (indexToHighlight) => {
    const updatedTags = getValues('tags').map((tag, index) => ({
      ...tag,
      highlighted: index === indexToHighlight,
    }));
    setValue('tags', updatedTags);
  };

  return (
    <Box mt={2}>
      <Typography variant="subtitle2" gutterBottom>
        Tags sugeridas:
      </Typography>
      <Box display="flex" gap={1} flexWrap="wrap" mb={2}>
        {SUGGESTED_TAGS.map((tag) => (
          <Button key={tag} variant="outlined" size="small" onClick={() => handleAddSuggested(tag)}>
            {tag}
          </Button>
        ))}
      </Box>

      {fields.map((field, index) => (
        <Box key={field.id} display="flex" alignItems="center" gap={1} mb={1}>
          <TextField
            label={`Tag ${index + 1}`}
            variant="filled"
            fullWidth
            {...register(`tags.${index}.description`)}
          />
          <IconButton
            onClick={() => handleHighlight(index)}
            color={field.highlighted ? 'warning' : 'default'}
          >
            {field.highlighted ? <StarIcon /> : <StarBorderIcon />}
          </IconButton>
          <IconButton color="error" onClick={() => remove(index)}>
            <DeleteIcon />
          </IconButton>
        </Box>
      ))}

      {fields.length < 10 && (
        <Button variant="outlined" onClick={() => append({ description: '', highlighted: false })}>
          Adicionar Tag
        </Button>
      )}
    </Box>
  );
};

export default ProductTagsEditor;
